import { render } from "./MissionPage.vue?vue&type=template&id=68f1002c"
import script from "./MissionPage.vue?vue&type=script&lang=js"
export * from "./MissionPage.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\manya\\Documents\\Development\\Production\\Vue\\bbf-africa-website\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__